module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"number-centers":"Amosando a páxina {0} de {1} para un total de {2} centros","seguinte":"Seguinte","anterior":"Anterior"},"es":{"number-centers":"Mostrando la página {0} de {1} para un total de {2} centros","seguinte":"Siguiente","anterior":"Anterior"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/App.vue
// module id = 150
// module chunks = 0